import * as R from 'ramda'
import moment from 'moment'
export default (properties, date) => {
	let res =  R.map(property => {
		return breakdown(property.mortgageStart, date, property.mortgageLoan, property.mortgageInterest, property.mortgageEnd, property._id)
	})(properties)
	res.total = R.pipe(R.values, R.reduce((total, item) => R.mergeWith((total, item) => {
		if(typeof(total) != "object"){
			return R.add(total,item)
		} else {
			return R.mergeWith(R.add, total, item)
		}
	}, total, item), {}))(res)
	return res
}

let breakdown = (loanStart, date, loanAmount, interestRate, loanEnd, propertyID) => {
	if(!(loanStart && date && loanAmount && interestRate && loanEnd)) return {principle: 0, interest: 0, balance: 0, total: {principle: 0, interest: 0}, payment: 0, paymentNumber: 0}
	let payments = moment(loanEnd).diff(moment(loanStart), 'months')
	let interestRatePerMonth = interestRate / 100 / 12
	let x = Math.pow(1 + interestRatePerMonth, payments)
	let payment = +((loanAmount * x * interestRatePerMonth)/(x-1)).toFixed(2)
	let interest, principle
	let remaining = loanAmount
	let totalInterest = 0
	let paymentNumber = moment(date).add(1,'day').diff(moment(loanStart).startOf('month'), 'months')
	if(paymentNumber < 0) paymentNumber = 0;

	let debug = "\n" + "paymentNumber" + "\t" + "interest" + "\t" + "principle" + "\t" + "remaining" + "\t" + "totalInterest"

	for (var i = 1; i <= paymentNumber; i++) {
		interest = +(remaining * interestRatePerMonth).toFixed(2)
		principle = +(payment - interest).toFixed(2)
		remaining -= principle
		totalInterest += interest
		debug += "\n" + i + "\t" + interest + "\t" + principle + "\t" + remaining + "\t" + totalInterest
	}
	return ({
		principle
	  , interest
	  , balance: remaining
	  , total: {
			principle: +(loanAmount - remaining).toFixed(2)
		  , interest: totalInterest
		}
	  , payment
	  , paymentNumber
	})
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/breakdown.js